export default __webpack_public_path__ + "static/media/Breast Left.20ac3c13.jpg";